import VGScrollbar from "./scrollbar";
import {onReady, findAll} from "../../../../modules/vegas/js/util";

function enableScrollbar() {
	[...findAll('[data-scrollbar]')].forEach(function (el) {
		VGScrollbar(el);
	});
}

onReady(enableScrollbar);
typeof onTurboRender !== 'undefined' && onTurboRender(enableScrollbar);

